<template>
  <DashboardLayout>
    <div class="d-flex align-items-center gap-2 mb-4 page-identifier">
      <p class="mb-0 main-identifier fw-semibold">Budget Management</p>
      <span class="material-symbols-outlined">keyboard_arrow_right</span>
      <p class="mb-0 sub-identifier">Create Economic Line Item</p>
    </div>

    <div class="d-flex justify-content-center">
      <div class="form-outer">
        <form @submit.prevent="handleSubmit">
          <div class="crud-form position-relative">

            <div class="form-inner">
              <div class="form-header d-flex justify-content-between align-items-center">
                  <h1 class="mb-0">Create Economic Line Item</h1>
              </div>

              <div class="form-body">
                <div class="row mt-2 mb-3">
                    <div class="col-md-12 row form-group position-relative floating-label-group">
                      <div class="col-md-3 label-left d-flex justify-content-end align-items-center"><label for="name" class="form-label">Economic Code</label></div>
                      <div class="col-md-9 input-right">
                        <input type="text" class="form-control" v-model="code" placeholder="Enter Economic Line Item Code" required>
                      </div>
                    </div>
                    <div class="col-md-12 row form-group position-relative floating-label-group">
                      <div class="col-md-3 label-left d-flex justify-content-end align-items-center"><label for="year" class="form-label">Economic Code Type</label></div>
                      <div class="col-md-9 input-right">
                        <select class="form-select" v-model="code_type" required>
                          <option value="" disabled>- Select Economic Code Type -</option>
                          <option value="2">Recurrent</option>
                          <option value="3">Capital</option>
                        </select>
                      </div>
                    </div>
                    <div class="col-md-12 row form-group position-relative floating-label-group">
                      <div class="col-md-3 label-left d-flex justify-content-end align-items-center"><label for="name" class="form-label">Description</label></div>
                      <div class="col-md-9 input-right">
                        <div class="col-md-12 input-right">
                            <textarea
                            class="form-control"
                            id="description"
                            v-model="description"
                            placeholder="Enter Economic Line Item Description"
                            rows="3"
                            required
                            ></textarea>
                        </div>
                      </div>
                    </div>
                </div>

                <div class="d-flex justify-content-center">
                  <button class="submit-btn" type="submit" :disabled="isLoading">
                    <span v-if="isLoading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    {{ isLoading ? 'Submitting...' : 'Submit' }}
                  </button>
                </div>
              </div>

            </div>

          </div>
        </form>
      </div>
    </div>

  </DashboardLayout>
</template>

<script setup>
import {ref, onMounted} from 'vue'
import axios from 'axios'
import Cookies from 'js-cookie';
import DashboardLayout from '../layout/DashboardLayout.vue'
import Swal from 'sweetalert2'

const root_api_url = process.env.VUE_APP_API_ROOT_URL

const code = ref('');
const description = ref('');
const code_type = ref('');

const isLoading = ref(false);




const handleSubmit = async () => {
  const token = Cookies.get('auth_token');

  const EliData = {
      economicCode: code.value,
      description: description.value.trim(),
      economicCodeType: code_type.value,
    };

  const iconHtmlSuccess = `<span class="iconify" data-icon="ci:circle-check" style="font-size: 100px; color: green;"></span>`
  const iconHtmlError = `<span class="iconify" data-icon="material-symbols:cancel-outline-rounded" style="font-size: 100px; color: red;"></span>`

  try {

    const result = await axios.post(`${root_api_url}/eli/eco-line-item`, EliData, {
        headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        },
    });

    if (result.status === 201) {

      Swal.fire({
        html: `${iconHtmlSuccess} <h1 style="font-weight:600;">Success</h1> <p>Economic Line Item Created Successfully</p> `,
        showConfirmButton: true,
        showCloseButton: true,
        icon: undefined,
      });

      code.value = '';
      description.value = '';
    }
  } catch (error) {
    // Swal.fire({
    //   html: `${iconHtmlError}
    //   <h1 style="font-weight:600;">Error</h1>
    //   <p>Failed to create Economic Line Item</p>`,
    //   showConfirmButton: true,
    //   showCloseButton: true,
    //   icon: undefined,
    // });

    if (error.response) {
      Swal.fire({
        html: `${iconHtmlError}
      <h1 style="font-weight:600;">Error</h1>
      <p>${error?.response?.data?.errorMessage || error?.response?.data?.error || 'Unexpected error occurred while creating Economic Line Item. Kindly contact administrator'}</p>`,
        showConfirmButton: true,
        showCloseButton: true,
        icon: undefined,
      });
    } else {
      Swal.fire({
        html: `${iconHtmlError}
      <h1 style="font-weight:600;">Error</h1>
      <p>Unexpected error occurred while creating Economic Line Item. Kindly contact administrator</p>`,
        showConfirmButton: true,
        showCloseButton: true,
        icon: undefined,
      });
    }
  } finally {
      isLoading.value = false;
  }
}

onMounted(() => {
    document.title = "Create Economic Line Item"
})

</script>
